// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3-5Bv","addWidgetButton":"Header_addWidgetButton__2T60G","dashboardTabs":"Header_dashboardTabs__3MsyS","active":"Header_active__2UW1h"};